import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const ADMIN_TOKEN_KEY = "paulvilas_admin_token";
const EMAIL_KEY = "paulvilas_lead_email";
const DRAFT_KEY = "paulvilas_inquiry_draft";

export const adminToken = {
  get: () => localStorage.getItem(ADMIN_TOKEN_KEY) || "",
  set: (t) => localStorage.setItem(ADMIN_TOKEN_KEY, t),
  clear: () => localStorage.removeItem(ADMIN_TOKEN_KEY),
};

export const draftStore = {
  saveLeadEmail: (email) => localStorage.setItem(EMAIL_KEY, email),
  getLeadEmail: () => localStorage.getItem(EMAIL_KEY) || "",
  saveDraft: (d) => localStorage.setItem(DRAFT_KEY, JSON.stringify(d)),
  getDraft: () => {
    try {
      return JSON.parse(localStorage.getItem(DRAFT_KEY) || "{}");
    } catch {
      return {};
    }
  },
  clearDraft: () => localStorage.removeItem(DRAFT_KEY),
};

export async function captureEmail(email) {
  const { data } = await axios.post(`${API}/leads/email-capture`, { email });
  return data;
}

export async function submitLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  return data;
}

export async function fetchLeads() {
  const token = adminToken.get();
  const { data } = await axios.get(`${API}/admin/leads`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function downloadLeadsCsv() {
  const token = adminToken.get();
  const res = await axios.get(`${API}/admin/leads/export.csv`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  const url = URL.createObjectURL(new Blob([res.data], { type: "text/csv" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `paulvilas-inquiries-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
